module.exports = __webpack_public_path__ + "img/save_filled_64.1cfc4742.svg";